import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PaymentsService } from '../../services/payments.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

@Component({
	selector: 'app-vendor-payment-remittance',
	templateUrl: './vendor-payment-remittance.component.html',
	styleUrls: ['./vendor-payment-remittance.component.scss']
})
export class VendorPaymentRemittanceComponent implements OnInit {
	loading = true;
	saving = false;
	enabled = false;
	trustedPreview: SafeHtml | null = null;
	loadError: string | null = null;
	color = 'blue';

	constructor(
		private paymentsService: PaymentsService,
		private sanitizer: DomSanitizer,
		private globalSearchService: GlobalSearchService
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.load();
	}

	load(): void {
		this.loading = true;
		this.loadError = null;
		this.paymentsService.getVendorRemittanceView().subscribe({
			next: (res: any) => {
				this.loading = false;
				if (res && res.success && res.preview_html) {
					this.enabled = res.enabled === '1' || res.enabled === true;
					this.trustedPreview = this.sanitizer.bypassSecurityTrustHtml(res.preview_html);
				} else {
					this.loadError = 'Could not load preview.';
				}
			},
			error: () => {
				this.loading = false;
				this.loadError = 'Could not load remittance settings.';
			}
		});
	}

	onToggle(checked: boolean): void {
		this.enabled = checked;
	}

	save(): void {
		this.saving = true;
		this.paymentsService.saveVendorRemittanceEnabled(this.enabled).subscribe({
			next: (res: any) => {
				this.saving = false;
				if (res && res.success) {
					this.enabled = res.enabled === '1' || res.enabled === true;
					this.globalSearchService.showNotification('Remittance email setting saved', 'success', 'bottom', 'right');
				} else {
					this.globalSearchService.showNotification('Save failed', 'warning', 'bottom', 'right');
				}
			},
			error: () => {
				this.saving = false;
				this.globalSearchService.showNotification('Save failed', 'danger', 'bottom', 'right');
			}
		});
	}
}
